const TitlePage = ({ text }) => {
  return (
    <div className="title-page anime-me">
      <h2 className="title-page--text">{text}</h2>
    </div>
  );
};

export default TitlePage;
